import { PrimaryHighlightsAttributeProps } from 'features/views/DetailView/attributes/primaryHighlights/types'

import { ExtractResponsiveValue, useResponsiveValue } from 'ui/styling/helpers/useResponsiveValue'

export const DEFAULT_SIZE = 'm' as const

type AttributeSize = NonNullable<ExtractResponsiveValue<PrimaryHighlightsAttributeProps['size']>>

export function useAttributeSize(size: PrimaryHighlightsAttributeProps['size']): AttributeSize {
    const effectiveSize = useResponsiveValue(size) ?? 'm'

    return effectiveSize
}
